import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, error, hint, className, id, ...rest },
  ref,
) {
  const inputId = id ?? `i-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <div className="space-y-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-[11px] font-semibold text-ink-muted uppercase tracking-wider"
        >
          {label}
        </label>
      )}
      <input
        {...rest}
        ref={ref}
        id={inputId}
        className={cn(
          'w-full h-10 px-3 rounded-lg',
          'bg-surface-elevated border border-surface-border text-ink',
          'placeholder:text-ink-faint',
          'focus:outline-none focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500',
          'transition-colors duration-150',
          error && 'border-loss focus:ring-loss/40 focus:border-loss',
          className,
        )}
      />
      {error ? (
        <p className="text-xs text-loss">{error}</p>
      ) : hint ? (
        <p className="text-xs text-ink-subtle">{hint}</p>
      ) : null}
    </div>
  );
});
